"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeMapToText = void 0;
// 见wiki 文档：https://wiki.maoyan.com/pages/viewpage.action?pageId=254938334
exports.typeMapToText = {
    1: '早鸟',
    2: '折扣',
    3: '套票',
    4: '满折',
    5: '满减',
    6: '满减',
};
